import { Component, Input } from '@angular/core';
import { RecargaService } from '../../../../services/recarga.service';
import { Plano } from '../../../../interfaces/recarga/recarga.interface';
import { StringUtil } from '../../../../infra/string-util';
import { Saldo } from '../../../../interfaces/saldo/saldo.interface';
import { SaldoService } from '../../../../services/saldo.service';
import { ToastrService } from 'ngx-toastr';
declare var bootstrap: any;

@Component({
  selector: 'app-modal-recarga',
  templateUrl: './modal-recarga.component.html',
  standalone: false
})
export class ModalRecargaComponent {
  planosRecarga: Plano[] = [];
  planoRecargaSelecionado: Plano | null = null;
  Util = StringUtil;
  saldo: Saldo | null = null;
  saldoAtualizado: number = 0;
  idPlanoRecargaSelecionado: number = 0;

  constructor(
    private recargaService: RecargaService,
    private saldoService: SaldoService,
    private toastrService: ToastrService
  ) {}

  async ngOnInit(){
    await this.obterPlanosRecarga();
    await this.obterSaldoAtual();
    this.calcularSaldoFinal();
    const modalElement = document.getElementById('modalRecarga');
    if (modalElement) {
      modalElement.addEventListener('hide.bs.modal', () => {
        this.fecharModal();
        this.reabrirModalListaContato();
      });
    }
  }

  async navegarParaRecargas(event: Event) {    
    if(!this.planoRecargaSelecionado || this.planoRecargaSelecionado.idPlanoPrePago === 0){
      this.toastrService.warning("Selecione um plano de recarga.");
      return;
    }
    await this.recargaService.navegarParaRecargas(event, this.planoRecargaSelecionado.idPlanoPrePago);    
    const modalElement = document.getElementById('modalRecarga');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      modalInstance?.hide();
    }
  }

  async obterPlanosRecarga(){
    this.planosRecarga = await this.recargaService.obterPlanosRecarga();    
  }

  async obterSaldoAtual(){
    this.saldo = await this.saldoService.obterSaldoAtual();
  }

  onChangePlanoRecarga(event: Event) {
    const idPlanoSelecionado = (event.target as HTMLSelectElement).value;
    this.planoRecargaSelecionado = this.planosRecarga.find(plano => plano.idPlanoPrePago === Number(idPlanoSelecionado)) || null;    
    this.calcularSaldoFinal();
  }

  calcularSaldoFinal(){
    if(this.planoRecargaSelecionado && this.planoRecargaSelecionado.idPlanoPrePago > 0){
      this.saldoAtualizado = this.saldo?.quantidade! + this.planoRecargaSelecionado.creditos;
    }
    else if(!this.planoRecargaSelecionado || this.planoRecargaSelecionado?.idPlanoPrePago === 0){
      this.saldoAtualizado = this.saldo?.quantidade!;
    }
  }

  fecharModal(){
    this.planoRecargaSelecionado = null;
    this.idPlanoRecargaSelecionado = 0;
    this.calcularSaldoFinal();
  }

  reabrirModalListaContato() {
    const modalListaContatoElement = document.getElementById('modalGerarListaContatos');
    if (modalListaContatoElement) {
      const modalListaContato = new bootstrap.Modal(modalListaContatoElement);
      modalListaContato.show();
    }
  }
}
